import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { CreateSampleType } from '../types/types'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

export const useGetSampleTypesQuery = () => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['sample-types'],
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/sample-types')
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}

export const useCreateSampleTypeMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (sampleType: CreateSampleType) => {
      const { data, error } = await authFetch().POST('/sample-types', {
        body: sampleType
      })
      if (error) {
        throwOnError(error)
      }
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['sample-types']
      })
    }
  })
}

export const useDeleteSampleTypeMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (sampleTypeId: number) =>
      await authFetch().DELETE('/sample-types/{sampleTypeId}', {
        params: {
          path: { sampleTypeId }
        }
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['sample-types']
      })
    }
  })
}
